import { createContext } from 'react';
import { store } from '@store';

export const appContext = createContext(store);
